import { render } from "./LaboratoryTestIndex.vue?vue&type=template&id=69429183"
import script from "./LaboratoryTestIndex.vue?vue&type=script&lang=js"
export * from "./LaboratoryTestIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__